// ordersstatus


import { Trans } from '@lingui/macro';
import React from 'react';

export enum ORDERSTATUS {
    CREATED = 'CREATED',
    COLLECTED = 'COLLECTED',
    COLLECTING = 'COLLECTING',
    COMPLETE = 'COMPLETE',
    CANCEL = 'CANCEL',
    WAITING_FOR_DELIVERY = 'WAITING_FOR_DELIVERY',
    DELIVERING = 'DELIVERING',
    DELIVERED_FULL = 'DELIVERED_FULL',
    DELIVERED_WITH_REJECT = 'DELIVERED_WITH_REJECT',
    REJECTED_ITEMS_RETURNED = 'REJECTED_ITEMS_RETURNED',
    WAITING_FOR_CUSTOMER = 'WAITING_FOR_CUSTOMER'
}

export const notEditedStatus: string[] =  ['CANCEL' , 'COMPLETE' ,'DELIVERED_FULL','DELIVERED_WITH_REJECT', 'REJECTED_ITEMS_RETURNED']

export enum ORDERSTATUSCOLOR {
    CREATED = 'red-400',
    COLLECTED = 'yellow-400',
    COLLECTING = 'yellow-500',
    COMPLETE = 'green-600',
    CANCEL = 'gray-400',
    WAITING_FOR_DELIVERY = 'pink-400',
    DELIVERING = 'blue-500',
    DELIVERED_FULL = 'green-500',
    DELIVERED_WITH_REJECT = 'green-200',
    REJECTED_ITEMS_RETURNED = 'indigo-400',
    WAITING_FOR_CUSTOMER = 'pink-400'
}


// Color chooser function
export const getColorOrders = (ordersStatus ?: string): string => {
    switch (ordersStatus) {
        case ORDERSTATUS.CREATED:
            return ORDERSTATUSCOLOR.CREATED
        case ORDERSTATUS.COLLECTING:
            return ORDERSTATUSCOLOR.COLLECTING
        case ORDERSTATUS.COLLECTED:
            return ORDERSTATUSCOLOR.COLLECTED
        case ORDERSTATUS.CANCEL:
            return ORDERSTATUSCOLOR.CANCEL
        case ORDERSTATUS.COMPLETE:
            return ORDERSTATUSCOLOR.COMPLETE
        case ORDERSTATUS.DELIVERING:
            return ORDERSTATUSCOLOR.DELIVERING
        case ORDERSTATUS.WAITING_FOR_DELIVERY:
            return ORDERSTATUSCOLOR.WAITING_FOR_DELIVERY
        case ORDERSTATUS.WAITING_FOR_CUSTOMER:
            return ORDERSTATUSCOLOR.WAITING_FOR_CUSTOMER
        case ORDERSTATUS.DELIVERED_FULL:
            return ORDERSTATUSCOLOR.DELIVERED_FULL
        case ORDERSTATUS.DELIVERED_WITH_REJECT:
            return ORDERSTATUSCOLOR.DELIVERED_WITH_REJECT
        case ORDERSTATUS.REJECTED_ITEMS_RETURNED:
            return ORDERSTATUSCOLOR.REJECTED_ITEMS_RETURNED
        default:
            return ORDERSTATUS.CREATED
    }
}

export const getTransStatus = (status: string) => {
    switch (status) {
        case 'CREATED':
            return <Trans>Created</Trans>
        case 'COLLECTING':
            return ( <Trans>Collecting</Trans> )
        case 'COLLECTED':
            return ( <Trans>Collected</Trans> )
        case 'COMPLETE':
            return <Trans>Order completed</Trans>
        case 'CANCEL':
            return <Trans>Cancelled</Trans>
        case 'WAITING_FOR_CUSTOMER':
            return <Trans>Waiting for customer</Trans>
        case 'WAITING_FOR_DELIVERY':
            return <Trans>Waiting for delivery</Trans>
        case 'DELIVERING':
            return <Trans>Delivering</Trans>
        case 'DELIVERED_FULL':
            return <Trans>Delivered full</Trans>
        case 'DELIVERED_WITH_REJECT':
            return <Trans>Delivered with reject</Trans>
        case 'REJECTED_ITEMS_RETURNED':
            return <Trans>Delivered items returned</Trans>
        default   :
            return status

    }
}
